export const getAnimatedHeight = (actualHeight, options) => {
    const { height, maxHeight, minHeight } = options;
    // Set and initial return height:
    // - actual height if `auto` is provided
    // - otherwise the numeric height
    const returnHeight = height === 'auto' ? actualHeight : height;
    // If the return height is greater than the max, flatten to the max
    if (maxHeight && returnHeight > maxHeight)
        return maxHeight;
    // If the return height is less than the min, raise to the min
    if (minHeight && returnHeight < minHeight)
        return minHeight;
    // Otherwise send out the initial return height
    return returnHeight;
};
